/* MenuBar.js */
import React, { useState } from 'react';
import '../css/MenuBar.css'; // 导入样式表
import menuIcon from '../svg/menu.svg'; // 导入菜单图标
import channelIcon from '../svg/mu-ch.svg'; // 导入信道分配图标
import wifiIcon from '../svg/wifi.svg'; // 导入Wi-Fi图标
import apsIcon from '../svg/Aps.svg'; // 导入APs图标
import bssidsIcon from '../svg/BSSIDs.svg'; // 导入BSSIDs图标
import clientIcon from '../svg/client.svg'; // 导入客户端图标
import bluetoothIcon from '../svg/bluetooth.svg'; // 导入蓝牙图标
import aboutIcon from '../svg/about.svg'; // 导入关于图标

const MenuBar = ({ onMenuItemSelect }) => {
  const [selectedOption, setSelectedOption] = useState(null); // 用于跟踪选中的菜单项
  const [isMenuOpen, setIsMenuOpen] = useState(false); // 状态钩子，用于管理菜单的显示状态

  // 切换菜单显示状态
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 处理菜单项点击事件
  const handleMenuItemClick = (menuItem) => {
    onMenuItemSelect(menuItem); // 调用父组件传递的回调函数，通知父组件菜单项被选中
    setSelectedOption(menuItem); // 更新选中的菜单项
    setIsMenuOpen(false); // 关闭菜单
  };

  // 处理遮罩层点击事件
  const handleOverlayClick = () => {
    setIsMenuOpen(false); // 关闭菜单
  };

  return (
    <div className="menu-bar">
      <img src={menuIcon} alt="Menu" className="menu-button" onClick={toggleMenu} />
      {/* 显示当前选中的菜单项 */}
      {selectedOption && (
        <span className="selected-menu-item">Wi-Fi-{selectedOption}</span>
      )}
      {/* 如果菜单是打开状态 */}
      {isMenuOpen && (
        <div>
          <div className="menu-overlay" onClick={handleOverlayClick}></div> {/* 遮罩层 */}
          <div className="menu-popup">
            {/* 渲染菜单选项 */}
            <div className="menu-options">
              {/* 这里添加菜单选项 */}
              <div className={`menu-option ${selectedOption === '信道分配图' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('信道分配图')}>
                <img src={channelIcon} alt="Channel Allocation" className="menu-icon" />
                <span>信道分配图</span>
              </div>
              {/* <div className={`menu-option ${selectedOption === '信道' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('信道')}>
                <img src={channelIcon} alt="Channels" className="menu-icon" />
                <span>信道</span>
              </div> */}
              <div className={`menu-option ${selectedOption === 'SSIDs' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('SSIDs')}>
                <img src={wifiIcon} alt="SSIDs" className="menu-icon" />
                <span>SSIDs</span>
              </div>
               <div className={`menu-option ${selectedOption === 'APs' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('APs')}>
                <img src={apsIcon} alt="APs" className="menu-icon" />
                <span>APs</span>
              </div>
              <div className={`menu-option ${selectedOption === 'BSSIDs' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('BSSIDs')}>
                <img src={bssidsIcon} alt="BSSIDs" className="menu-icon" />
                <span>BSSIDs</span>
              </div>
              {/*<div className={`menu-option ${selectedOption === '客户端' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('客户端')}>
                <img src={clientIcon} alt="Clients" className="menu-icon" />
                <span>客户端</span>
              </div>
              <div className={`menu-option ${selectedOption === '蓝牙' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('蓝牙')}>
                <img src={bluetoothIcon} alt="Bluetooth" className="menu-icon" />
                <span>蓝牙</span>
              </div> */}
              <div className={`menu-option ${selectedOption === '关于' ? 'selected' : ''}`} onClick={() => handleMenuItemClick('关于')}>
                <img src={aboutIcon} alt="About" className="menu-icon" />
                <span>关于</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuBar;
